<template>
    <img class="logo object-contain" :src="logoSrc" alt="Logo">
</template>
<script>
const DEFAULT_LOGO = 'https://www.omagroup.com/wp-content/uploads/2017/12/new-port-tariff-benin.jpg'

export default {
    props: {
        name: String,
    },
    computed: {
        logoSrc() {
            const account = this.$page?.props?.auth?.current_account
            const defaultLogo = this.$page?.props?.default_logo || DEFAULT_LOGO
            if (this.name === 'white') {
                return account?.logo_white || account?.logo || defaultLogo
            }
            return account?.logo || defaultLogo
        },
    },
}
</script>
